import { PageContent, csx } from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'
import { PromotionsContextProvider } from '../../providers/PromotionsContextProvider'
import { AccountLimitsAlert } from './AccountLimitsAlert'
import { AnalyticsWrapper } from './AnalyticsWrapper'

export function Content(props: DefaultProps) {
  return (
    <PageContent layout="wide" className={csx({ display: 'block' })}>
      <PromotionsContextProvider>
        <AccountLimitsAlert />

        <AnalyticsWrapper>{props.children}</AnalyticsWrapper>
      </PromotionsContextProvider>
    </PageContent>
  )
}
